export const BUSINESS_TRAVELLER_BUSINESS_EMPLOYEE_COUNT_OPTIONS: Array<[App.BusinessTraveller.BusinessEmployeeCountOptions, string]> = [
  ['1-20', '1-20'],
  ['21-50', '21-50'],
  ['51-200', '51-200'],
  ['200+', '200+'],
]

export const SMALL_TEAM_THRESHOLD: App.BusinessTraveller.BusinessEmployeeCountOptions = '1-20'
